<template>
  <div class="flex-col page">
    <div class="flex-col self-stretch relative group_5">
      <div class="self-stretch section_3"></div>
      <span class="self-start font_4 text_6">证书/报告申请</span>
      <div class="flex-col justify-start items-center self-start text-wrapper btn"
         @click="goProjectApply"
      >
        <span class="font_2 text_7">申请入口</span>
      </div>
      <span class="self-start font_4 text_9">审核状态查询</span>
      <div class="type-box">
          <span
            class="type-btn"
            :class="{active: selectKey == item.key}"
            v-for="(item, index) in typeData"
            :key="index"
            @click="changeTab(item.key)"
          >
            {{item.value}}
          </span>
      </div>
      <div class="flex-col self-stretch relative group_12">
        <el-table
          :data="tableData"
          border
          style="width: 100%">
          <el-table-column
            prop="num"
            label="序号"
            width="50"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="zsbh"
            width="190"
            label="证书编号">
            <template slot-scope="scope">
              <p class="row">
                <span class="name">{{scope.row.zsbh.name}}</span>
                <span
                  class="status"
                  :class="{
                    fail: scope.row.zsbh.type === 0
                  }"
                >{{getStatusName(scope.row.zsbh.type)}}</span>
              </p>
            </template>
          </el-table-column>
          <el-table-column
            prop="jgmc"
            label="发证机构名称">
          </el-table-column>
          <el-table-column
            prop="xmmc"
            label="创新项目名称">
          </el-table-column>
          <el-table-column
            prop="rzdx"
            label="认证对象">
          </el-table-column>
          <el-table-column
            prop="audit_state"
            label="审核状态"
            align="center">
            <template slot-scope="scope">
              <p class="row">
                  <span
                    class="name"
                    :class="{
                      pass: scope.row.audit_state == 2,
                      unPass: scope.row.audit_state == 3
                    }"
                  >{{scope.row.audit_state_text}}</span>
              </p>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data () {
    return {
      selectKey: '1',
      typeData: [
        { key: '1', value: '审核中', active: true },
        { key: '2', value: '审核通过', active: false },
        { key: '3', value: '审核不通过', active: false }
      ],
      tableData: [
      ],
      dataConfig: {
        1: [],
        2: [],
        3: []
      },
      page: 1,
      limit: 100,
      total: 0,
      form: {
        zsbh: '',
        jgmc: '',
        xmmc: '',
        qymc: '',
        rzdx: ''
      }
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      this.search()
    },
    async getList () {
      const res = await this.$https.getZsbgsqList({
        ...this.form, page: this.page, limit: this.limit
      })
      this.total = res.data.data.count
      res.data.data.list.forEach(v => {
        this.dataConfig[v.audit_state].push({
          ...v,
          zsbh: {
            name: v.zsbh,
            type: v.zsbh_state
          }
        })
      })
      this.tableData = this.dataConfig[this.selectKey]
    },
    changeTab (key) {
      this.selectKey = key
      this.tableData = this.dataConfig[this.selectKey]
    },
    search () {
      // this.$message.success('搜索')
      this.page = 1
      this.getList()
    },
    goProjectApply () {
      this.$router.push('/server?type=9&id=1')
    },
    getStatusName (type) {
      const config = {
        2: '注销',
        1: '有效'
      }
      return config[type]
    }
  }
}
</script>

<style scoped lang="less">
  .row .name{
    &.pass{
      color: #00c46d;
    }
    &.unPass{
      color: red;
    }
  }
  .btn{
    cursor: pointer;
  }
  .row{
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;

    .name{
      font-family: PingFang;
      font-weight: 500;
      font-size: 12px;
      color: #333333;
      line-height: 18px;
    }
    .status{
      background: #19891E;
      font-weight: 800;
      font-size: 10px;
      color: #FFFFFF;
      line-height: 18px;
      text-align: center;
      padding: 0px 10px;
      margin-left: 10px;

      &.fail{
        background: #D60000;
      }
    }
  }
  .btn{
    cursor: pointer;
  }
  .type-box{
    display: flex;
    flex-direction: row;
    align-items: center;
    border-bottom: 1px solid #e5e5e5;
    margin-top: 33px;
    width: 1066px;

    .type-btn{
      text-align: center;
      width: 104px;
      height: 36px;
      background: #FFFFFF;
      border: 1px solid #E5E5E5;

      font-weight: bold;
      font-size: 14px;
      color: #999999;
      line-height: 36px;
      margin-right: 16px;
      cursor: pointer;

      &.active{
        background-color: #006ED1;
        color: white;
      }
    }
  }

  .group_12 {
    width: 1066px;
    margin-top: 20px;
    padding-bottom: 47px;

    /deep/ thead th{
      background: #E8F0FA;
      color: #323232;
    }
    /deep/ .el-table--border, .el-table--group {
      border: 1px solid #bebebe !important;
    }
    /deep/ .el-table--border  td,
    /deep/ .el-table--border th,
    /deep/ .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed {
      border-right: 1px solid #bebebe !important;
    }
    /deep/ .el-table--border th.el-table__cell {
      border-bottom: 1px solid #bebebe;
      color: #000000;
    }
    /deep/ .el-table  td, .el-table th.is-leaf  {
      border-bottom: 1px solid #bebebe!important;
    }
    .section_12 {
      padding: 14px 26px;
      background-color: #e8f0fa;
      border-left: solid 1px #bebebe;
      border-right: solid 1px #bebebe;
      border-top: solid 1px #bebebe;
      border-bottom: solid 1px #bebebe;
      .text_21 {
        margin-right: 709px;
      }
    }
    .section_18 {
      margin-top: 279px;
      padding: 18px 33px;
      background-color: #ffffff;
      border-left: solid 1px #bebebe;
      border-right: solid 1px #bebebe;
      border-top: solid 1px #bebebe;
      border-bottom: solid 1px #bebebe;
      .text_28 {
        margin-right: 662px;
      }
    }
    .section_13 {
      padding: 18px 35px;
      background-color: #ffffff;
      border-left: solid 1px #bebebe;
      border-right: solid 1px #bebebe;
      border-top: solid 1px #bebebe;
      border-bottom: solid 1px #bebebe;
      .text_22 {
        margin-right: 660px;
      }
    }
    .pos_4 {
      position: absolute;
      left: 0;
      right: 0;
      top: 44px;
    }
    .font_9 {
      font-size: 12px;
      font-family: PingFang;
      line-height: 10px;
      color: #333333;
    }
    .section_14 {
      padding: 18px 34px;
      background-color: #f6f6f6;
      border-left: solid 1px #bebebe;
      border-right: solid 1px #bebebe;
      border-top: solid 1px #bebebe;
      border-bottom: solid 1px #bebebe;
      .text_23 {
        margin-right: 661px;
        line-height: 11px;
      }
      .text_25 {
        margin-right: 649px;
      }
      .text_29 {
        line-height: 9px;
      }
      .text_30 {
        margin-right: 643px;
      }
    }
    .pos_5 {
      position: absolute;
      left: 0;
      right: 0;
      top: 91px;
    }
    .section_15 {
      padding: 16px 34px 19px;
      background-color: #ffffff;
      border-left: solid 1px #bebebe;
      border-right: solid 1px #bebebe;
      border-top: solid 1px #bebebe;
      border-bottom: solid 1px #bebebe;
      .text_24 {
        margin-right: 643px;
      }
    }
    .pos_6 {
      position: absolute;
      left: 0;
      right: 0;
      top: 138px;
    }
    .pos_7 {
      position: absolute;
      left: 0;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
    }
    .section_16 {
      padding: 19px 33px 16px;
      background-color: #ffffff;
      border-left: solid 1px #bebebe;
      border-right: solid 1px #bebebe;
      border-top: solid 1px #bebebe;
      border-bottom: solid 1px #bebebe;
      .text_26 {
        margin-right: 674px;
      }
    }
    .pos_8 {
      position: absolute;
      left: 0;
      right: 0;
      top: 232px;
    }
    .section_17 {
      padding: 16px 34px 19px;
      background-color: #f6f6f6;
      border-left: solid 1px #bebebe;
      border-right: solid 1px #bebebe;
      border-top: solid 1px #bebebe;
      border-bottom: solid 1px #bebebe;
      .text_27 {
        margin-right: 661px;
      }
    }
    .pos_9 {
      position: absolute;
      left: 0;
      right: 0;
      top: 279px;
    }
    .pos_10 {
      position: absolute;
      left: 0;
      right: 0;
      top: 372px;
    }
    .image_5 {
      width: 2px;
      height: 421px;
    }
    .pos_3 {
      position: absolute;
      left: 86px;
      bottom: 0;
    }
  }
  .ml-5 {
    margin-left: 5px;
  }
  .ml-103 {
    margin-left: 103px;
  }
  .ml-53 {
    margin-left: 53px;
  }
  .ml-109 {
    margin-left: 109px;
  }
  .ml-27 {
    margin-left: 27px;
  }
  .ml-17 {
    margin-left: 17px;
  }
  .mt-27 {
    margin-top: 27px;
  }
  .ml-99 {
    margin-left: 99px;
  }
  .page {
    background-color: #ffffff;
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    height: 100%;
    .group {
      padding-bottom: 37px;
      .section {
        padding: 53px 0 49px;
        background-color: #ffffff;
        .text_2 {
          color: #004290;
          font-size: 39px;
          font-family: Swiss721BT;
          font-weight: 900;
          line-height: 29px;
        }
        .text_3 {
          color: #004290;
          font-size: 32px;
          font-family: Alibaba;
          line-height: 31px;
        }
      }
      .section_2 {
        padding: 16px 362px 16px 388px;
        background-color: #006ed1;
        .group_2 {
          margin-left: 85px;
        }
        .group_3 {
          margin-left: 80px;
        }
        .image_2 {
          width: 13px;
          height: 8px;
        }
        .group_4 {
          margin-left: 81px;
        }
        .image {
          width: 28px;
          height: 32px;
        }
        .text_4 {
          line-height: 16px;
        }
      }
    }
    .group_5 {
      /*padding: 0 240px;*/
      /*.section_3 {*/
        /*background-color: #0067d1;*/
        /*height: 3px;*/
      /*}*/
      .text_6 {
        /*margin-left: 287px;*/
        /*margin-top: 58px;*/
        line-height: 16px;
      }
      .text-wrapper {
        /*margin-left: 289px;*/
        margin-top: 19px;
        padding: 14px 0;
        background-color: #006ed1;
        width: 181px;
        .text_7 {
          line-height: 15px;
        }
      }
      .text_9 {
        /*margin-left: 288px;*/
        margin-top: 38px;
        line-height: 15px;
      }
      .section_6 {
        margin-right: 83px;
        margin-top: 69px;
        background-color: #e5e5e5;
        width: 1066px;
        height: 2px;
      }
      .group_9 {
        padding: 17px 0 360px;
        .section_7 {
          margin-right: 76px;
          padding: 14px 3px;
          background-color: #e8f0fa;
          width: 1072px;
          border-left: solid 1px #bebebe;
          border-right: solid 1px #bebebe;
          border-top: solid 1px #bebebe;
          border-bottom: solid 1px #bebebe;
          .font_6 {
            font-size: 14px;
            font-family: PingFang;
            line-height: 15.5px;
            color: #333333;
          }
          .text_11 {
            font-size: 15px;
            line-height: 15px;
          }
          .text_12 {
            font-size: 15px;
            line-height: 15px;
          }
          .group_12 {
            margin-left: 142px;
            .text_13 {
              font-size: 15px;
              line-height: 15px;
            }
            .text_14 {
              font-size: 15px;
              line-height: 15px;
            }
          }
          .text_15 {
            margin-left: 133px;
            font-size: 15px;
            line-height: 16px;
          }
          .text_16 {
            margin-left: 127px;
            line-height: 16px;
          }
        }
        .section_8 {
          padding: 13px;
          background-color: #ffffff;
          width: 1072px;
          border-left: solid 1px #bebebe;
          border-right: solid 1px #bebebe;
          border-top: solid 1px #bebebe;
          border-bottom: solid 1px #bebebe;
          .text_18 {
            margin-left: 122px;
          }
          .text_19 {
            margin-left: 134px;
            font-size: 12px;
          }
        }
        .pos_11 {
          position: absolute;
          right: 76px;
          top: 60px;
        }
        .section_9 {
          padding: 12px 13px;
          background-color: #f9f9f9;
          width: 1072px;
          border-left: solid 1px #bebebe;
          border-right: solid 1px #bebebe;
          border-top: solid 1px #bebebe;
          border-bottom: solid 1px #bebebe;
          .text_21 {
            line-height: 9px;
          }
          .text_20 {
            margin-left: 122px;
          }
          .text_23 {
            margin-left: 134px;
            font-size: 12px;
          }
        }
        .pos_12 {
          position: absolute;
          right: 76px;
          top: 105px;
        }
        .font_7 {
          font-size: 11px;
          font-family: PingFang;
          line-height: 15.5px;
          color: #333333;
        }
        .font_8 {
          font-size: 11px;
          font-family: PingFang;
          line-height: 10px;
          color: #333333;
        }
        .font_9 {
          font-size: 11px;
          font-family: PingFang;
          line-height: 10px;
          color: #ffffff;
        }
        .font_10 {
          font-size: 11px;
          font-family: PingFang;
          line-height: 12px;
          color: #333333;
        }
        .font_11 {
          font-size: 11px;
          font-family: PingFang;
          line-height: 12px;
          color: #00c46d;
        }
        .section_10 {
          padding: 12px 13px;
          background-color: #ffffff;
          width: 1072px;
          border-left: solid 1px #bebebe;
          border-right: solid 1px #bebebe;
          border-top: solid 1px #bebebe;
          border-bottom: solid 1px #bebebe;
          .text_24 {
            line-height: 9px;
          }
          .text_26 {
            margin-left: 122px;
          }
          .text_27 {
            margin-left: 134px;
            font-size: 12px;
          }
          .text_31 {
            line-height: 11px;
          }
        }
        .pos_13 {
          position: absolute;
          right: 76px;
          top: 150px;
        }
        .text-wrapper_5 {
          padding: 5px 0;
          background-color: #19891e;
          width: 39px;
          height: 20px;
        }
        .section_11 {
          padding: 13px;
          background-color: #f9f9f9;
          width: 1072px;
          border-left: solid 1px #bebebe;
          border-right: solid 1px #bebebe;
          border-top: solid 1px #bebebe;
          border-bottom: solid 1px #bebebe;
          .text_29 {
            margin-left: 122px;
            line-height: 11px;
          }
          .text_30 {
            margin-left: 134px;
            font-size: 12px;
          }
        }
        .pos_14 {
          position: absolute;
          right: 76px;
          top: 195px;
        }
        .text-wrapper_4 {
          padding: 4px 0;
          background-color: #19891e;
          width: 39px;
          height: 19px;
          .text_17 {
            font-size: 10px;
          }
          .text_28 {
            font-size: 10px;
          }
        }
        .pos_15 {
          position: absolute;
          right: 76px;
          top: 240px;
        }
        .text_25 {
          font-size: 10px;
        }
        .pos_16 {
          position: absolute;
          right: 76px;
          top: 285px;
        }
        .pos_17 {
          position: absolute;
          right: 76px;
          top: 330px;
        }
        .pos_18 {
          position: absolute;
          right: 76px;
          top: 375px;
        }
        .text_22 {
          font-size: 10px;
        }
        .group_11 {
          width: 1px;
          height: 404px;
          border-left: solid 1px #bebebe;
          border-right: solid 1px #bebebe;
          border-top: solid 1px #bebebe;
          border-bottom: solid 1px #bebebe;
        }
        .pos_6 {
          position: absolute;
          left: 331px;
          top: 18px;
        }
        .image_7 {
          width: 2px;
          height: 404px;
        }
        .pos_7 {
          position: absolute;
          left: 596px;
          bottom: 0;
        }
        .pos_9 {
          position: absolute;
          right: 454px;
          bottom: 0;
        }
        .pos_8 {
          position: absolute;
          right: 677px;
          bottom: 0;
        }
        .pos_10 {
          position: absolute;
          right: 260px;
          bottom: 0;
        }
      }
      .section_4 {
        padding: 57px 24px 313px;
        background-color: #f9f9f9;
        width: 200px;
        .image_3 {
          width: 18px;
          height: 19px;
        }
        .text_5 {
          line-height: 13px;
        }
        .group_6 {
          margin-top: 36px;
          .image_4 {
            width: 18px;
            height: 20px;
          }
        }
        .group_7 {
          margin-top: 35px;
          padding-left: 33px;
          .image_5 {
            width: 20px;
            height: 20px;
          }
          .text_8 {
            color: #006ed1;
            font-size: 14px;
            font-family: PingFang;
            line-height: 13px;
          }
        }
        .group_8 {
          margin-top: 34px;
        }
        .group_10 {
          margin-top: 40px;
          .image_6 {
            width: 18px;
            height: 18px;
          }
        }
      }
      .pos {
        position: absolute;
        left: 241px;
        top: 0;
      }
      .section_5 {
        background-color: #006ed1;
        width: 5px;
        height: 37px;
      }
      .pos_2 {
        position: absolute;
        left: 240px;
        top: 159px;
      }
      .text-wrapper_2 {
        padding: 10px 0;
        background-color: #ffffff;
        width: 104px;
        border-left: solid 1px #e5e5e5;
        border-right: solid 1px #e5e5e5;
        border-top: solid 1px #e5e5e5;
        border-bottom: solid 1px #e5e5e5;
        .font_5 {
          font-size: 14px;
          font-family: PingFang;
          line-height: 14px;
          color: #999999;
        }
      }
      .pos_3 {
        position: absolute;
        left: 531px;
        top: 226px;
      }
      .pos_5 {
        position: absolute;
        left: 771px;
        top: 226px;
      }
      .text-wrapper_3 {
        padding: 10px 0;
        background-color: #006ed1;
        width: 104px;
        border-left: solid 1px #e5e5e5;
        border-right: solid 1px #e5e5e5;
        border-top: solid 1px #e5e5e5;
        border-bottom: solid 1px #e5e5e5;
        .text_10 {
          color: #ffffff;
        }
      }
      .pos_4 {
        position: absolute;
        left: 651px;
        top: 226px;
      }
      .font_3 {
        font-size: 14px;
        font-family: PingFang;
        line-height: 14px;
        color: #666666;
      }
    }
    .font_2 {
      font-size: 16px;
      font-family: PingFang;
      line-height: 15.5px;
      color: #ffffff;
    }
    .image_8 {
      margin-left: 268px;
      margin-top: 36px;
      width: 26px;
      height: 26px;
    }
    .group_13 {
      margin-top: 15px;
      .section_12 {
        padding: 63px 246px 0;
        background-image: url('https://ide.code.fun/api/image?token=674dac92797f850011f0a860&name=899810897f3558f396f6dc015ddb4126.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        .text-wrapper_6 {
          padding: 14px 0;
          background-color: #006ed1;
          width: 164px;
        }
        .group_14 {
          padding: 26px 6px 49px;
          .text-wrapper_7 {
            flex: 1 1 446px;
            padding: 28px 0;
            background-color: #e0edf9;
            height: 75px;
            border-left: solid 1px #006ed1;
            border-right: solid 1px #006ed1;
            border-top: solid 1px #006ed1;
            border-bottom: solid 1px #006ed1;
            .text_32 {
              line-height: 16px;
            }
          }
        }
      }
      .section_13 {
        padding: 8px 234px 36px 360px;
        background-image: url('https://ide.code.fun/api/image?token=674dac92797f850011f0a860&name=4d73456eb0616f8bd0f475b81babc110.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        .image_9 {
          width: 41px;
          height: 41px;
        }
        .text_33 {
          color: #b2b3b8;
          font-size: 24px;
          font-family: PingFang;
          line-height: 23px;
        }
        .image_10 {
          margin-bottom: 4px;
          width: 40px;
          height: 43px;
        }
        .font_12 {
          font-size: 16px;
          font-family: PingFang;
          line-height: 15.5px;
          color: #b2b3b8;
        }
        .text_34 {
          line-height: 15px;
        }
        .text_36 {
          color: #006ed1;
          font-size: 24px;
          font-family: PingFang;
          font-weight: 700;
          line-height: 20px;
        }
        .image_11 {
          margin-bottom: 4px;
          width: 31px;
          height: 43px;
        }
        .text_35 {
          line-height: 16px;
        }
        .text_37 {
          color: #006ed1;
          font-size: 20px;
          font-family: PingFang;
          line-height: 19px;
        }
        .section_14 {
          background-color: #2e3142;
          width: 204px;
          height: 188px;
        }
        .font_13 {
          font-size: 14px;
          font-family: PingFang;
          line-height: 10px;
          color: #939598;
        }
        .text_39 {
          line-height: 11px;
        }
        .text_38 {
          margin-left: 3px;
          line-height: 11px;
        }
        .text_40 {
          margin-left: 45px;
          line-height: 11px;
        }
        .text_41 {
          margin-left: 3px;
          line-height: 11px;
        }
      }
    }
    .font {
      font-size: 18px;
      font-family: PingFang;
      line-height: 18px;
      color: #ffffff;
    }
    .font_4 {
      font-size: 16px;
      font-family: PingFang;
      line-height: 15.5px;
      color: #333333;
    }
    .text {
      text-transform: uppercase;
    }
  }
</style>
